(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function initHoverDropdowns() {
      if (window.innerWidth < 990) return;
      document.querySelectorAll('.header__inline-menu header-menu').forEach(function (menu) {
        var details = menu.querySelector(':scope > details');
        if (!details) return;
        menu.addEventListener('mouseenter', function () {
          details.setAttribute('open', '');
        });
        menu.addEventListener('mouseleave', function () {
          details.removeAttribute('open');
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHoverDropdowns);
    } else {
      initHoverDropdowns();
    }
  })();

  /* Scrollable desktop menu with chevrons */
  (function () {
    var currentOffset = 0;
    var nav, list, leftBtn, rightBtn;

    function getMaxOffset() {
      return Math.max(0, list.scrollWidth - nav.clientWidth);
    }

    function updateChevrons() {
      var maxOffset = getMaxOffset();
      if (maxOffset <= 1) {
        leftBtn.classList.remove('is-visible');
        rightBtn.classList.remove('is-visible');
        return;
      }
      leftBtn.classList.toggle('is-visible', currentOffset > 2);
      rightBtn.classList.toggle('is-visible', currentOffset < maxOffset - 2);
    }

    function scrollMenu(direction) {
      var maxOffset = getMaxOffset();
      currentOffset += direction * 200;
      currentOffset = Math.max(0, Math.min(currentOffset, maxOffset));
      list.style.transform = 'translateX(' + (-currentOffset) + 'px)';
      updateChevrons();
    }

    function initScrollableMenu() {
      if (window.innerWidth < 990) return;

      nav = document.querySelector('.header__inline-menu');
      if (!nav) return;
      list = nav.querySelector('.list-menu--inline');
      if (!list) return;

      leftBtn = document.createElement('button');
      leftBtn.type = 'button';
      leftBtn.className = 'header-menu-chevron header-menu-chevron--left';
      leftBtn.setAttribute('aria-label', 'Scroll menu left');
      leftBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';

      rightBtn = document.createElement('button');
      rightBtn.type = 'button';
      rightBtn.className = 'header-menu-chevron header-menu-chevron--right';
      rightBtn.setAttribute('aria-label', 'Scroll menu right');
      rightBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';

      nav.appendChild(leftBtn);
      nav.appendChild(rightBtn);

      leftBtn.addEventListener('click', function () { scrollMenu(-1); });
      rightBtn.addEventListener('click', function () { scrollMenu(1); });

      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(function () {
          var maxOffset = getMaxOffset();
          if (currentOffset > maxOffset) {
            currentOffset = maxOffset;
            list.style.transform = 'translateX(' + (-currentOffset) + 'px)';
          }
          updateChevrons();
        }).observe(nav);
      }

      updateChevrons();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initScrollableMenu);
    } else {
      initScrollableMenu();
    }

    window.addEventListener('resize', function () {
      if (!nav || !list) return;
      if (window.innerWidth < 990) {
        currentOffset = 0;
        list.style.transform = '';
        if (leftBtn) leftBtn.classList.remove('is-visible');
        if (rightBtn) rightBtn.classList.remove('is-visible');
      } else {
        updateChevrons();
      }
    });
  })();

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
